export interface iLatestResult<R> {
	stale: boolean;
	response: R;
}

export const createLatestRequest = () => {
	let latest = 0;
	let inflight: { key: string; promise: Promise<unknown> } | null = null;

	return async <R>(key: string, run: () => Promise<R>): Promise<iLatestResult<R>> => {
		const id = ++latest;
		let promise = inflight?.key === key ? (inflight.promise as Promise<R>) : null;
		if (!promise) {
			const started = run();
			const entry = { key, promise: started as Promise<unknown> };
			inflight = entry;
			started.then(
				() => {
					if (inflight === entry) inflight = null;
				},
				() => {
					if (inflight === entry) inflight = null;
				},
			);
			promise = started;
		}
		const response = await promise;
		return { stale: id !== latest, response };
	};
};
